module.exports = __webpack_public_path__ + "img/home_reason.9910e85e.png";